module.exports = __webpack_public_path__ + "img/b0066846b2cc929a665e2ceb7fecd468.9b919b58.png";